import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TemplateDashboard\SubscribeToTemplateDashboardController::__invoke
* @see app/Http/Controllers/TemplateDashboard/SubscribeToTemplateDashboardController.php
* @route '/api/template-dashboard/subscribe'
*/
const SubscribeToTemplateDashboardController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SubscribeToTemplateDashboardController.url(options),
    method: 'post',
})

SubscribeToTemplateDashboardController.definition = {
    methods: ["post"],
    url: '/api/template-dashboard/subscribe',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\TemplateDashboard\SubscribeToTemplateDashboardController::__invoke
* @see app/Http/Controllers/TemplateDashboard/SubscribeToTemplateDashboardController.php
* @route '/api/template-dashboard/subscribe'
*/
SubscribeToTemplateDashboardController.url = (options?: RouteQueryOptions) => {
    return SubscribeToTemplateDashboardController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\TemplateDashboard\SubscribeToTemplateDashboardController::__invoke
* @see app/Http/Controllers/TemplateDashboard/SubscribeToTemplateDashboardController.php
* @route '/api/template-dashboard/subscribe'
*/
SubscribeToTemplateDashboardController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SubscribeToTemplateDashboardController.url(options),
    method: 'post',
})

export default SubscribeToTemplateDashboardController